import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import PostForm from '../PostForm';

class NewPost extends Component {
  render() {
    return (
      <div className="list-wrapper">
        <Typography variant="headline" component="h4">Add new post</Typography>
        <PostForm {...this.props}>
          <div className="button-group">
            <Button variant="raised" color="primary" type="submit">Save</Button>
            <Button
              component={Link}
              to={`/${this.props.screen}`}
              variant="raised"
            >
              Discard
            </Button>
          </div>
        </PostForm>
      </div>
    )
  }
}

export default NewPost;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/NewPost/index.js